import PropTypes from 'prop-types';
// @mui
import CloseIcon from '@mui/icons-material/Close';
import { useTheme, Box, Typography, Stack } from '@mui/material';
import { userMesaageType } from 'constants/ui.constants';
import _ from 'lodash';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { Fragment } from 'react';

interface Props {
  severity?: userMesaageType;
  text?: string;
  subText?: string | object;
  children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
  icon?: any;
}

export const CustomAlert = (props: Props) => {
  const theme = useTheme();
  const color =
    props.severity === userMesaageType.ERROR
      ? theme.palette.error.light
      : props.severity === userMesaageType.WARNING
        ? theme.palette.warning.light
        : 'inherit';
  const subtext = _.isEqual(props.text, 'errors.code.500') ? 'errors.code.500.description' : props.subText;
  return (
    <Box
      sx={{
        padding: '12px',
        backgroundColor: color,
        borderRadius: '8px',
      }}
    >
      <AlertTitle {...props} />
      {subtext && <AlertText subText={subtext} />}
      {props.children}
    </Box>
  );
};

export const AlertTitle = (props: Props) => {
  const theme = useTheme();
  const t = useAppSelector(selectTranslations);

  const color =
    props.severity === userMesaageType.ERROR
      ? theme.palette.error.main
      : props.severity === userMesaageType.WARNING
        ? theme.palette.warning.main
        : 'inherit';

  const textcolor =
    props.severity === userMesaageType.ERROR
      ? theme.palette.error.main
      : props.severity === userMesaageType.WARNING
        ? theme.palette.warning.dark
        : 'inherit';

  return (
    <Box sx={{ height: '44px' }}>
      <Stack direction="row" spacing={2}>
        <Box
          sx={{
            width: '44px',
            height: '44px',
            backgroundColor: theme.palette.root.basicWhite_006,
            borderRadius: '100%',
          }}
        >
          <Box
            sx={{
              width: '32px',
              margin: '6px',
              height: '32px',
              backgroundColor: color,
              borderRadius: '100%',
              textAlign: 'center',
            }}
          >
            {props.icon ? (
              <props.icon sx={{ color: '#fff', height: '32px', width: '20px' }} />
            ) : (
              <CloseIcon sx={{ color: '#fff', height: '32px', width: '20px' }} />
            )}
          </Box>
        </Box>
        <Typography variant="h4" sx={{ color: textcolor, lineHeight: '44px' }}>
          {t(props.text || '', props.text)}
        </Typography>
      </Stack>
    </Box>
  );
};

export const AlertText = (props: Props) => {
  const theme = useTheme();
  const t = useAppSelector(selectTranslations);
  const getSubtext = () => {
    if (_.isObject(props.subText)) {
      return (
        <Stack>
          {_.keys(props.subText).map((key) => (
            <Stack direction="row">
              <Typography variant="boldBody1">{t(key)}: </Typography>
              <Typography>{t(_.get(props.subText, key))}</Typography>
            </Stack>
          ))}
        </Stack>
      );
    } else {
      return <Typography>{t(props.subText || '')}</Typography>;
    }
  };
  return (
    <Box sx={{ height: '44px', whiteSpace: 'pre-wrap' }}>
      <Stack direction="row" spacing={2}>
        {getSubtext()}
      </Stack>
    </Box>
  );
};
